import { useState } from "react";
import { t } from "../i18n";

interface Props {
  /** How many extra reveals they get for handing over the address. */
  bonus: number;
  dadName: string;
  onSubmit: (email: string) => Promise<void>;
  onSkip: () => void;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function EmailGate({ bonus, dadName, onSubmit, onSkip }: Props) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const valid = EMAIL_RE.test(email.trim());

  async function submit() {
    if (!valid || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await onSubmit(email.trim().toLowerCase());
    } catch (e) {
      setError(e instanceof Error ? e.message : t("email_gate.error"));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="card reading-card">
      <h2 className="archetype">{t("email_gate.title")}</h2>
      <p className="reasoning">
        {t("email_gate.body", { name: dadName, bonus })}
      </p>
      <div className="field" style={{ width: "100%" }}>
        <input
          type="email"
          autoFocus
          inputMode="email"
          autoComplete="email"
          placeholder={t("email_gate.placeholder")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") void submit();
          }}
        />
      </div>
      {error && <div className="error">{error}</div>}
      <button
        className="btn btn-primary"
        disabled={!valid || submitting}
        onClick={() => void submit()}
      >
        {submitting ? t("email_gate.submitting") : t("email_gate.submit", { bonus })}
      </button>
      <button className="text-link" onClick={onSkip} type="button">
        {t("email_gate.skip")}
      </button>
    </div>
  );
}
